import { Injectable } from '@angular/core';
import { Settings } from './app.settings.model';

@Injectable()
export class AppSettings {
    public settings = new Settings(
        'Certacure',
        true,
        true,
        true,
        true,
        true,
        'vertical',
        'default',
        'indigo-light',
        false
    )
}

